import React, { useContext } from 'react';

import { BlogContext } from '../../context';

import type { TBlogContentBody } from './models';
import { headingRenderer } from './helpers/heading-renderer';
import { remarkPlugin } from './helpers/remark-plugin';

export const BlogContentBody = ({
    MarkdownContainer,
    Text,
    config,
    content,
    linkTargetBlank,
}: TBlogContentBody) => {
    const { headingsRef } = useContext(BlogContext);

    return (
        <MarkdownContainer
            content={content}
            linkTargetBlank={linkTargetBlank}
            pluggins={{ remarkPlugins: [[remarkPlugin, { headingsRef }]] }}
            renderers={{
                h2: headingRenderer(Text, config),
            }}
        />
    );
};
